const TICKET_HAS_BEEN_EXPIRED = 1004;
const INVALID_PIN = 1112;
const USER_LOCKED = 1106;
export const USER_LINKED_TO_OTHER_USER = 1901;

class ErrorCodeHelper {
    static isTicketExpiredError (error) {
        return getErrorCode(error) == TICKET_HAS_BEEN_EXPIRED;
    }
    static isInvalidPin (error) {
        return getErrorCode(error) == INVALID_PIN;
    }
    static isUserLocked (error) {
        return getErrorCode(error) == USER_LOCKED;
    }

    static isUserLinkedToOtherVirtualUser (error) {
        return getErrorCode(error) == USER_LINKED_TO_OTHER_USER;
    }
}

const getErrorCode = (error) => {
    let result = undefined;
    if (error.response && error.response.data) {
        try {
            const parsedMessage = error.response.data;
            if (parsedMessage.ErrorCode) {
                result = parsedMessage.ErrorCode;
            }
        }
        catch (ex) {
        }
    }

    return result;
};

export default ErrorCodeHelper;
